<template>
  <div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete User</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          Are you sure do you want to delete {{user.fullname}}?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="dangerButton" @click="deleteUser">Delete permanently</button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false)
    }
  },
  computed: {
    ...mapState('userManagement', {
      showDeleteModal: state => state.showDeleteModal,
      user: state => state.user
    })
  },
  methods: {
    ...mapActions('userManagement', ['openDeleteModal', 'getUsers']),
    deleteUser() {
      this.dangerButton = appButton.isLoadingDanger(true)
      axios
        .delete(`api/users/${this.user.id}`)
        .then(response => {
          appToast.success(response.data)
          this.default()
        })
        .catch(error => {
          console.log(error)
          appToast.danger(
            'Something went wrong. Cannot delete user with associate product'
          )
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false)
        })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false
      })
      this.getUsers()
    }
  }
}
</script>
